import store from '../store';

export const sectionTemplate = () => {

    const sectionData = store.get("departmentList");
    const searchOption = store.get("searchOption");
    const selectedDepartment = searchOption.Department.DepartmentId;

    const department = sectionData
        .filter(section => section.DepartmentId === selectedDepartment)
        .map(section => section.Sections)
        .flat()
        .map(section => `
            <option value="${section.SectionId}">
                ${section.Name}
            </option>
        `);

    const allOption = [`
        <option value=""> 
            Vis alle 
        </option>
    `];

    return [...allOption,...department];
};